import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { FileUploader }         from 'ng2-file-upload';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class ClasificadosService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'anuncio'].join('/');
  }

  public getImagenesClasificado(id): Observable<any> {
    return this.http
      .get([this.ApiUrl, id, 'imagenes'].join('/'))
      .map(res => res.json());
  }

  public getResumenMovimientos(fechaInicial, fechaFinal) {
    return this.http.get([
      this.ApiUrl,
      'reporte-resumen',
      fechaInicial,
      fechaFinal].join('/')
    ).map(res => res.json());
  }
  public getDetalleMovimientos(fechaInicial, fechaFinal) {
    return this.http.get([
      this.ApiUrl,
      'reporte-detalle',
      fechaInicial,
      fechaFinal].join('/')
    ).map(res => res.json());
  }

  public save(model: any): Observable<any> {
    let file: FileUploader = model.imagenes;

    model.imagenes = '';
    model.negociable = 0;

    // model = JSON.parse(JSON.stringify(model));

    delete model['imagenes'];

    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            try {
              if (file.queue.length > 0) {
                file.authToken = this.auth.getToken();
                file.options.url = [this.ApiUrl, data.id, 'upload'].join('/');

                file.queue.forEach(queue => {
                  queue.url = [this.ApiUrl, data.id, 'upload'].join('/');

                  queue.upload();

                  if (!!queue._xhr) {
                    queue._xhr.onreadystatechange = function(e) {
                      if (queue._xhr.readyState == 4) {
                        data.image = [data.id, 'jpg'].join('.');

                        observer.next(data);
                      }
                    }                
                  }
                });
              } else {
                observer.next(data);
              }              
            }
            catch (ex) {
              console.error(ex);
            }
          },
          error => console.error(error)
        );      
    });
  }

  public update(id:any, model: any): Observable<any> {
    let file: FileUploader = model.imagenes;

    model.imagenes = '';

    delete model['imagenes'];

    return new Observable(observer => {
      super.update(id, model)
        .subscribe(
          data => {
            if (file.queue.length > 0) {
              file.authToken = this.auth.getToken();
              file.options.url = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if (file.queue[0]._xhr.readyState == 4) {
                  data.image[data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }
            } else {
              observer.next(data);
            }
          },
          error => console.error(error)
        );      
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/clasificados/clasificados.service.ts